import { gql } from "@apollo/client";

export const AssetLocationIotSystem = gql`
    query AssetLocationIotSystem ($id: ID!) {
        assetLocation (id: $id) {
            id
            system {
                id
                systemType
                installedBaseNode {
                    id
                    title
                }
            }
        }
    }
`;
